import React from 'react'
import { Search } from 'lucide-react'
import { mergeClasses } from '@/helpers/styling'

export function SearchInput(props: {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  className?: string
}) {
  return (
    <label className={mergeClasses(`
        flex items-center gap-2 h-8 px-2.5 m-0 flex-grow
        rounded-md border-[1px] border-border bg-white0
        focus-within:ring-2 focus-within:ring-[#51479e]/40`, props.className)}>
      <Search size={13} className="shrink-0 text-muted-foreground" aria-hidden />
      <input
        type="search"
        aria-label={props.placeholder}
        placeholder={props.placeholder}
        value={props.value}
        onChange={e => props.onChange(e.target.value)}
        className="flex-1 min-w-0 h-full border-none bg-transparent outline-none text-[13px] placeholder:text-muted-foreground"
      />
    </label>
  )
}
